/* Functions here is to handle everything about
 * drop down list value that not getting from API call
 */
import { SHARED } from '@/constants'
import { ACTIVATION_STATUS } from '@/constants/enums'
import i18n from '@/i18n'

export function getOptionAll(isStringVal = false) {
  return {
    title: i18n.t('label.all'),
    text: i18n.t('label.all'),
    value: isStringVal ? SHARED.DEFAULT_ALL_VALUE_STR : SHARED.DEFAULT_ALL_VALUE
  }
}

export function getActivationStatus(hasOptionAll, isBoolValue = false) {
  let ddl = []

  if (hasOptionAll) {
    ddl.push(getOptionAll())
  }

  ddl.push({
    text: i18n.t(`enumActivationStatus[0].${ACTIVATION_STATUS.ACTIVE}`),
    value: isBoolValue ? Boolean(ACTIVATION_STATUS.ACTIVE) : ACTIVATION_STATUS.ACTIVE
  })
  ddl.push({
    text: i18n.t(`enumActivationStatus[0].${ACTIVATION_STATUS.INACTIVE}`),
    value: isBoolValue ? Boolean(ACTIVATION_STATUS.INACTIVE) : ACTIVATION_STATUS.INACTIVE
  })

  return ddl
}

export function getWeekDays() {
  let ddl = []

  ddl.push({
    name: i18n.t(`enumWeekDay[0].1`),
    value: i18n.t(`enumWeekDay[0].1`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].2`),
    value: i18n.t(`enumWeekDay[0].2`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].3`),
    value: i18n.t(`enumWeekDay[0].3`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].4`),
    value: i18n.t(`enumWeekDay[0].4`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].5`),
    value: i18n.t(`enumWeekDay[0].5`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].6`),
    value: i18n.t(`enumWeekDay[0].6`),
  })
  ddl.push({
    name: i18n.t(`enumWeekDay[0].7`),
    value: i18n.t(`enumWeekDay[0].7`),
  })

  return ddl
}

export function getAccountLockStatus(hasOptionAll, isBoolValue = false) {
  let ddl = []

  if (hasOptionAll) {
    ddl.push(getOptionAll())
  }

  ddl.push({
    text: i18n.t(`enumAccountLockStatus[0].${ACTIVATION_STATUS.ACTIVE}`),
    value: isBoolValue ? Boolean(ACTIVATION_STATUS.ACTIVE) : ACTIVATION_STATUS.ACTIVE
  })
  ddl.push({
    text: i18n.t(`enumAccountLockStatus[0].${ACTIVATION_STATUS.INACTIVE}`),
    value: isBoolValue ? Boolean(ACTIVATION_STATUS.INACTIVE) : ACTIVATION_STATUS.INACTIVE
  })

  return ddl
}

export function getLocationsFromLookups(locationsLookups) {
  return [
    {
      text: i18n.t('label.state'),
      value: SHARED.DEFAULT_ALL_VALUE_STR
    },
    ...locationsLookups.map((l) => {
      return {
        text: l.location,
        value: l.location
      }
    })
  ]
}

export function getLanguages() {
  let languages = [];

  languages.push({
    code: 'ms',
    name: i18n.t('languages.ms.name'), // Translated name for 'Bahasa Melayu'
    flag: '🇲🇾',
  });

  languages.push({
    code: 'en',
    name: i18n.t('languages.en.name'), // Translated name for 'English'
    flag: '🇺🇸',
  });

  languages.push({
    code: 'zh',
    name: i18n.t('languages.zh.name'), // Translated name for 'Chinese'
    flag: '🇨🇳',
  });

  languages.push({
    code: 'hi',
    name: i18n.t('languages.hi.name'), // Translated name for 'Hindi'
    flag: '🇮🇳',
  });

  return languages;
}

export function getCountries() {
  let countries = [];

  countries.push({
    value: 1,
    name: i18n.t('country.mly.name'), // Translated name for 'Bahasa Melayu'
    flag: '🇲🇾',
  });

  countries.push({
    value: 2,
    name: i18n.t('country.sg.name'), // Translated name for 'Singapore'
    flag: '🇸🇬',
  });

  return countries;
}

export function getAnswerTypes() {
  let types = [];

  types.push({
    code: 1,
    name: i18n.t('answerTypes.long.name'), // Translated name for 'Bahasa Melayu'
  });

  types.push({
    code: 2,
    name: i18n.t('answerTypes.short.name'), // Translated name for 'Bahasa Melayu'
  });

  types.push({
    code: 3,
    name: i18n.t('answerTypes.shortTextMarks.name'), // Translated name for 'Bahasa Melayu'
  });

  types.push({
    code: 0,
    name: i18n.t('answerTypes.option.name'), // Translated name for 'Bahasa Melayu'
  });

  return types;
}

export function getDiscountMethods() {
  let methods = [];

  // methods.push({
  //   code: 1,
  //   name: i18n.t('discountMethods.code.name'), // Translated name for 'Bahasa Melayu'
  // });
  methods.push({
    code: 2,
    name: i18n.t('discountMethods.value.name'), // Translated name for 'Bahasa Melayu'
  });
  methods.push({
    code: 3,
    name: i18n.t('discountMethods.percentage.name'), // Translated name for 'Bahasa Melayu'
  });


  return methods;
}

export function getPromotionType() {
  let methods = [];

  methods.push({
    code: 1,
    name: i18n.t('sendPromotionType.whatsapp.name'), // Translated name for 'Bahasa Melayu'
  });
  methods.push({
    code: 2,
    name: i18n.t('sendPromotionType.email.name'), // Translated name for 'Bahasa Melayu'
  });
  methods.push({
    code: 3,
    name: i18n.t('sendPromotionType.sms.name'), // Translated name for 'Bahasa Melayu'
  });

  return methods;
}

export function getShellLifeTime() {
  let times = [];

  times.push({
    code: i18n.t('shellLifeTime.n/a.name'),
    name: i18n.t('shellLifeTime.n/a.name'), // Translated name for 'Bahasa Melayu'
  });
  times.push({
    code: i18n.t('shellLifeTime.2.name'),
    name: i18n.t('shellLifeTime.2.name'), // Translated name for 'Bahasa Melayu'
  });
   times.push({
    code: i18n.t('shellLifeTime.5.name'),
    name: i18n.t('shellLifeTime.5.name'), // Translated name for 'Bahasa Melayu'
  });

  return times;
}

/*
|------------------------------------------------------------------------------
| Multi-select options
|------------------------------------------------------------------------------
|
| The admin listings' filters are multi-selects, so they need option lists
| WITHOUT an "All" row: in a multi-select, selecting nothing already means
| "all", and an All option that has to be deselected before a real choice
| registers is a control that fights the user. getActivationStatus(true) is
| still right for the single-selects it was written for.
|
| Values are numbers (1 / 0), not booleans, because they are serialised into a
| query string -- `is_active[]=true` is the string "true", which
| `whereIn('is_active', ['true'])` does not match on MySQL.
*/

export function getActivationStatusMulti() {
  return [
    { text: i18n.t(`enumActivationStatus[0].${ACTIVATION_STATUS.ACTIVE}`), value: 1 },
    { text: i18n.t(`enumActivationStatus[0].${ACTIVATION_STATUS.INACTIVE}`), value: 0 },
  ]
}

export function getAccountLockStatusMulti() {
  return [
    { text: i18n.t('label.lock'), value: 1 },
    { text: i18n.t('label.unlock'), value: 0 },
  ]
}

export function getYesNoMulti() {
  return [
    { text: i18n.t('label.yes'), value: 1 },
    { text: i18n.t('label.no'), value: 0 },
  ]
}

/**
 * The configuration table's `value_type` column.
 *
 * Hardcoded rather than fetched: these are the eight types
 * App\Constants\ConfigurationCodeConstants declares and the backend validates
 * against, so a list that could drift from them would be worse than one that
 * cannot. The labels are deliberately the developer words -- somebody on this
 * screen is choosing between a boolean and a string, not between "a switch"
 * and "some text".
 */
export function getConfigurationValueTypes() {
  return [
    { text: 'string', value: 'string' },
    { text: 'integer', value: 'integer' },
    { text: 'boolean', value: 'boolean' },
    { text: 'double', value: 'double' },
    { text: 'date', value: 'date' },
    { text: 'dateTime', value: 'dateTime' },
    { text: 'image', value: 'image' },
    { text: 'json', value: 'json' },
  ]
}

/**
 * The bot skills a new brand can start with.
 *
 * Must match ai_bot's own skill names -- the backend posts them straight
 * through as `{skill: {enabled: true}}` and ai_bot's schema refuses an unknown
 * one. Kept in step with TenantStoreRequest's `in:` rule.
 */
export function getBotSkills() {
  return [
    { text: i18n.t('organization.skillRag'), value: 'rag' },
    { text: i18n.t('organization.skillHandoff'), value: 'handoff' },
    { text: i18n.t('organization.skillSmalltalk'), value: 'smalltalk' },
    { text: i18n.t('organization.skillAppointment'), value: 'appointment' },
    { text: i18n.t('organization.skillLead'), value: 'lead' },
    { text: i18n.t('organization.skillLoan'), value: 'loan' },
    { text: i18n.t('organization.skillEcommerce'), value: 'ecommerce' },
    { text: i18n.t('organization.skillComplaint'), value: 'complaint' },
    // Not a conversation skill like the others: it is the brand's OWN backend
    // exposed to the bot as tools (balance, promotions). Listed here anyway,
    // because to an operator it is the same question — "may the bot do this
    // for my players" — and it needs the credentials below to work.
    { text: i18n.t('organization.skillJk'), value: 'jk' },
  ]
}

/**
 * The brand filter on the user listing.
 *
 * 'platform' is a real option rather than an absence: the staff seats have
 * tenant_id NULL, and `tenant_id[]=null` matches nothing in SQL, so the server
 * reads the literal string and turns it into a whereNull. See
 * App\Helpers\Filters\UserFilter.
 */
export function getTenantOptions(tenants, includePlatform = true) {
  const options = includePlatform
    ? [{ text: i18n.t('label.platformAllBrands'), value: 'platform' }]
    : []

  return options.concat(
    (tenants || []).map((t) => ({
      text: t.name,
      value: t.tenant_id,
    }))
  )
}
